import { LocationLevelEnum, StoreEnum } from "@/enums";
import { IMaybe, ISelect } from "@/types";
import { create, StateCreator } from "zustand";
import { devtools } from "zustand/middleware";
import useHFStore from "./HFLevel";
import useLayerStore from "./Layer";
import useLGAStore from "./LgaLevel";
import useUtilStore from "@/data/util";

export interface WLState {
  selectedWard: IMaybe<string>;
  wardList: IMaybe<ISelect[]>;
  wardName: IMaybe<string>;
}

export interface WLActions {
  setSelectedWard: (ward: IMaybe<string>) => void;
  setWardList: (wardList: IMaybe<ISelect[]>) => void;
  onWardChange: (id: IMaybe<string>) => void;
}

export const storeCreator: StateCreator<WLState & WLActions> = (set) => ({
  selectedWard: null,
  wardList: null,
  wardName: null,
  setSelectedWard: (selectedWard) => {
    const { wardList } = useWardStore.getState();
    set({
      selectedWard,
      wardName:
        (wardList?.find((el) => el?.value === selectedWard)?.label as string) ??
        null,
    });
  },

  // Set the ward list
  setWardList: (wardList) => set({ wardList }),

  // Handle ward change
  onWardChange: async (id) => {
    const { setSearchPhcText } = useUtilStore.getState();
    const { setSelectedHF } = useHFStore.getState();
    const { loadLocationBoundary } = useLayerStore.getState();
    const { selectedLga } = useLGAStore.getState();
    const { setSelectedWard } = useWardStore.getState();

    setSearchPhcText("");

    if (!id) {
      setSelectedWard(null);
      if (selectedLga) loadLocationBoundary(selectedLga, LocationLevelEnum.LGA);
      return;
    }

    setSelectedHF(null);
    setSelectedWard(id);
    loadLocationBoundary(id, LocationLevelEnum.WARD);
  },
});

const useWardStore = create<WLState & WLActions>(
  devtools(storeCreator, { name: StoreEnum.WL_STORE }) as StateCreator<
    WLState & WLActions
  >
);

export default useWardStore;
